/**
 * Feature flag system for progressive enhancement
 *
 * Allows independent enabling/disabling of new features for staged rollout
 * Configure via environment variables (VITE_FEATURE_*)
 */

export const FEATURES = {
  WIN_PROBABILITY: {
    enabled: import.meta.env.VITE_FEATURE_WIN_PROB !== 'false', // Default ON in dev
    label: 'Win Probability Display',
    description: 'Show uncertainty-aware win probabilities instead of ratings'
  },
  ADVANCED_FILTERS: {
    enabled: import.meta.env.VITE_FEATURE_ADV_FILTERS !== 'false',
    label: 'Advanced Filters',
    description: 'Range sliders and competitiveness presets'
  },
  GRADIENT_COLORS: {
    enabled: import.meta.env.VITE_FEATURE_GRADIENT !== 'false',
    label: 'Gradient Color System',
    description: 'OKLCH-based continuous gradient'
  }
};

/**
 * Check if a feature is enabled
 *
 * @param {string} feature - Feature key from FEATURES object
 * @returns {boolean} True if feature is enabled
 */
export function isEnabled(feature) {
  return FEATURES[feature]?.enabled ?? false;
}

/**
 * Get all enabled features
 *
 * @returns {Array<string>} Array of enabled feature keys
 */
export function getEnabledFeatures() {
  return Object.keys(FEATURES).filter(key => FEATURES[key].enabled);
}

/**
 * Get feature configuration
 *
 * @param {string} feature - Feature key
 * @returns {Object|null} Feature config or null if not found
 */
export function getFeatureConfig(feature) {
  return FEATURES[feature] || null;
}
